<template>
  <v-dialog
    v-model="modalAdddevis"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Ajouter un devis</span>
      </v-card-title>
      <v-card-text v-if="modalAdddevis">
        <v-container v-show="loadingstatus">
          Ajout du devis en cours...
        </v-container>
        <v-container v-show="!loadingstatus">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="newdevis.nom"
                    class="purple-input"
                    label="Nom"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="newdevis.adresse"
                    class="purple-input"
                    label="Adresse"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newdevis.cp"
                    class="purple-input"
                    label="Code postal"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newdevis.ville"
                    class="purple-input"
                    label="Ville"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newdevis.mail"
                    class="purple-input"
                    label="Courriel"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newdevis.tel"
                    class="purple-input"
                    label="Téléphone"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <span>Préférence de contact</span>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-checkbox
                    v-model="newdevis.selectcontactmail"
                    label="Courriel"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-checkbox
                    v-model="newdevis.selectcontacttel"
                    label="Téléphone"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="newdevis.piece"
                    class="purple-input"
                    label="Nombre de pièces"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="newdevis.surface"
                    class="purple-input"
                    label="Surface totale (m2)"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="newdevis.angle"
                    class="purple-input"
                    label="Nombre d’angles"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newdevis.perimetre"
                    class="purple-input"
                    label="Périmètre de la pièce"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="newdevis.couleur"
                    class="purple-input"
                    label="Couleur"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md12>
                  <span>Message</span>
                  <v-textarea
                    v-model="newdevis.contenu"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions v-show="!loadingstatus">
        <v-spacer/>
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Adddevis')">Annuler</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="addDevis()">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import { db } from '@/plugins/firebase'
import moment from 'moment'

export default {
  data: () => ({
    configck: {
      language: 'fr',
      removePlugins: [ 'Heading' ],
      toolbar: [ 'bold', 'italic', 'bulletedList', 'blockQuote' ]
    },
    show: false,
    invalidlog: false,
    menu: false,
    menu1: false,
    loadingstatus: false,
    newdevis: {
      publie: 'new',
      nom: '',
      adresse: '',
      cp: '',
      ville: '',
      mail: '',
      tel: '',
      selectcontactmail: false,
      selectcontacttel: false,
      piece: '',
      couleur: '',
      surface: '',
      angle: '',
      perimetre: '',
      message: ''
    },
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters(['modalAdddevis'])
  },
  methods: {
    ...mapActions(['closeModal']),
    addDevis (newdevis) { // <-- and here
      this.loadingstatus = true
      const informations = this.newdevis
      informations.creation = moment().format('YYYY-MM-DD')
      db.collection('devis').add(informations)
      this.newdevis = {
        publie: 'new',
        nom: '',
        adresse: '',
        cp: '',
        ville: '',
        mail: '',
        tel: '',
        selectcontactmail: false,
        selectcontacttel: false,
        piece: '',
        couleur: '',
        surface: '',
        angle: '',
        perimetre: '',
        message: ''
      }
      this.loadingstatus = false
      this.closeModal('Adddevis')
    }

  }
}
</script>

<style lang="scss">

.calendar{
  .v-btn {
      color: rgba(0, 0, 0, 0.87) !important;
      padding: 0 0 !important;
  }
  .v-btn {
    align-items: center !important;
    border-radius: 4px !important;
    display: inline-flex !important;
    flex: 0 0 auto !important;
    font-weight: 500 !important;
    letter-spacing: 0.0892857143em !important;
    justify-content: center !important;
    max-width: 100% !important;
    outline: 0 !important;
    position: relative !important;
    text-decoration: none !important;
    text-indent: 0.0892857143em !important;
    text-transform: uppercase !important;
    transition-duration: 0.28s !important;
    transition-property: box-shadow, transform, opacity !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    user-select: none !important;
    vertical-align: middle !important;
    white-space: nowrap !important;
  }
  .v-date-picker-table .v-btn {
    z-index: auto !important;
    margin: 0 !important;
    font-size: 12px !important;
  }
  .v-date-picker-table--date td {
    width: 45px !important;
  }
  .v-btn--rounded {
    border-radius: 28px !important;
  }
  .v-date-picker-table td, .v-date-picker-table th {
      text-align: center;
      position: relative;
  }
  .v-date-picker-table--date .v-btn {
    height: 32px !important;
    width: 32px !important;
  }
  .v-btn:not(.v-btn--disabled) {
    will-change: box-shadow;
  }
  .v-btn__content {
    align-items: center !important;
    color: inherit !important;
    display: flex !important;
    flex: 1 0 auto !important;
    justify-content: inherit !important;
    line-height: normal !important;
    position: relative !important;
  }
}
</style>
